import { useState, useEffect } from 'react';

export function useForecastPanel() {
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [panelWidth, setPanelWidth] = useState(380);
  const [isResizing, setIsResizing] = useState(false);
  const [expandedVariableSection, setExpandedVariableSection] = useState(false);
  const [expandedLocationSection, setExpandedLocationSection] = useState(false);
  const [expandedModelSection, setExpandedModelSection] = useState(false);
  const [expandedTimeRangeSection, setExpandedTimeRangeSection] = useState(false);

  const handlePanelToggle = () => {
    setIsPanelOpen(!isPanelOpen);
    if (isPanelOpen) {
      // Reset expansion state when closing panel
      setExpandedVariableSection(false);
      setExpandedLocationSection(false);
      setExpandedModelSection(false);
      setExpandedTimeRangeSection(false);
    }
  };

  const handleOpenPanelWithVariableExpansion = () => {
    setIsPanelOpen(true);
    setExpandedVariableSection(true);
    setExpandedLocationSection(false);
    setExpandedModelSection(false);
    setExpandedTimeRangeSection(false);
  };

  const handleOpenPanelWithLocationExpansion = () => {
    setIsPanelOpen(true);
    setExpandedVariableSection(false);
    setExpandedLocationSection(true);
    setExpandedModelSection(false);
    setExpandedTimeRangeSection(false);
  };

  const handleOpenPanelWithModelExpansion = () => {
    setIsPanelOpen(true);
    setExpandedVariableSection(false);
    setExpandedLocationSection(false);
    setExpandedModelSection(true);
    setExpandedTimeRangeSection(false);
  };

  const handleOpenPanelWithTimeRangeExpansion = () => {
    setIsPanelOpen(true);
    setExpandedVariableSection(false);
    setExpandedLocationSection(false);
    setExpandedModelSection(false);
    setExpandedTimeRangeSection(true);
  };

  const handlePanelClose = () => {
    setIsPanelOpen(false);
    setExpandedVariableSection(false);
    setExpandedLocationSection(false);
    setExpandedModelSection(false);
    setExpandedTimeRangeSection(false);
  };

  // Trigger window resize event when panel opens/closes to notify charts
  useEffect(() => {
    const timer = setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 300); // Wait for transition to complete

    return () => clearTimeout(timer);
  }, [isPanelOpen, panelWidth]);

  return {
    // State
    isPanelOpen,
    panelWidth,
    isResizing,
    expandedVariableSection,
    expandedLocationSection,
    expandedModelSection,
    expandedTimeRangeSection,
    // Setters
    setPanelWidth,
    setIsResizing,
    setExpandedVariableSection,
    setExpandedLocationSection,
    setExpandedModelSection,
    setExpandedTimeRangeSection,
    // Handlers
    handlePanelToggle,
    handleOpenPanelWithVariableExpansion,
    handleOpenPanelWithLocationExpansion,
    handleOpenPanelWithModelExpansion,
    handleOpenPanelWithTimeRangeExpansion,
    handlePanelClose,
  };
}
